import React from "react";
import { Col, Input, Label, Row, TabPane } from "reactstrap";
import AsyncSelect from "react-select/async";
import { isEmpty } from "lodash";

export default function Referrals({
  loadingSpecialties,
  loadMedicalStaffs,
  onChange,
  subTabReferences,
  pageEdit,
  isPageModalHistory,
}) {
  const { appointmentHistoryReferral } = subTabReferences;
  return (
    <TabPane tabId={5}>
      <Row form>
        <Col md="3">
          <Label>Especialidad:</Label>
          <AsyncSelect
            isDisabled={isPageModalHistory}
            placeholder="Buscar Especialidad"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item}
            loadOptions={loadingSpecialties}
            cacheOptions
            isClearable={!pageEdit}
            defaultOptions
            value={
              isEmpty(appointmentHistoryReferral?.speciality)
                ? null
                : appointmentHistoryReferral?.speciality
            }
            onChange={(item) => {
              onChange(
                "tabPrescription",
                { speciality: item || {} },
                "subTabReferences",
                "appointmentHistoryReferral"
              );
            }}
          />
        </Col>
        <Col md="3">
          <Label>Médico:</Label>
          <AsyncSelect
            placeholder="Buscar Médico"
            getOptionLabel={(item) => item.label}
            getOptionValue={(item) => item}
            loadOptions={loadMedicalStaffs}
            isClearable
            cacheOptions
            defaultOptions
            isDisabled={
              isEmpty(appointmentHistoryReferral?.speciality) ||
              isPageModalHistory
            }
            value={
              appointmentHistoryReferral?.medicalName
                ? { id: 1, label: appointmentHistoryReferral?.medicalName }
                : null
            }
            onChange={(item) =>
              onChange(
                "tabPrescription",
                {
                  ...appointmentHistoryReferral,
                  medicalName: item?.label || "",
                },
                "subTabReferences",
                "appointmentHistoryReferral"
              )
            }
          />
        </Col>
      </Row>
      <Row form className="mt-4">
        <Col className="d-flex flex-lg-column">
          <Label>Observaciones:</Label>
          <Input
            type="textarea"
            disabled={isPageModalHistory}
            onBlur={({ target: { value } }) =>
              onChange(
                "tabPrescription",
                { ...appointmentHistoryReferral, observation: value },
                "subTabReferences",
                "appointmentHistoryReferral"
              )
            }
            defaultValue={appointmentHistoryReferral?.observation || ""}
          />
        </Col>
      </Row>
    </TabPane>
  );
}
